import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { ActivityLogDto, RobinJrActivityLogDto } from '../model';

type GetActivityLogResponse = {
  count: number;
  next: string | null;
  previous: string | null;
  results: ActivityLogDto[];
};

class CandidateClient extends BaseClient {
  getActivityLog(
    esPersonId: string,
    { limit = 10, offset = 0 }: { limit?: number; offset?: number } = {},
  ): AxiosPromise<GetActivityLogResponse> {
    return this.request({
      url: `${hosts.campaignsApi}/candidates/${esPersonId}/activity_logs`,
      method: 'GET',
      params: { limit, offset },
    });
  }

  getRobinJrActivityLog(campaignId: number, esPersonId: string): AxiosPromise<RobinJrActivityLogDto> {
    return this.request({
      url: `${hosts.campaignsApi}/rj_activity_logs/`,
      method: 'GET',
      params: { es_person_id: esPersonId, campaign_id: campaignId },
    });
  }

  getHistory(esPersonId: string): AxiosPromise<any[]> {
    return this.request({
      url: `${hosts.campaignsApi}/candidates/${esPersonId}/history/`,
      method: 'GET',
    });
  }

  deleteFollowUp(id: number): AxiosPromise<void> {
    return this.request({
      url: `${hosts.notificationsApi}/follow_up/${id}`,
      method: 'DELETE',
    });
  }
}

export const candidateClient = new CandidateClient();
